import styled from 'styled-components';

export const ContainerOption = styled.div`
    display: flex;
    justify-content: ${({ spaceBetween }) => (spaceBetween ? 'flex-end' : 'start')};
    width: ${({ full }) => (full ? '100%' : '49%')};
    background: ${(props) => props.theme.white} 0% 0% no-repeat padding-box;
    border: 1px solid ${(props) => props.theme.lightGrey20Link};
    border-radius: 8px;
    margin: 8px 0;
    padding: ${({ hasSpacing }) => (hasSpacing ? '25px 32px' : '0px')};
    max-width: 404px;

    &:hover{
        cursor: pointer;
    }
`;
